module.exports = __webpack_public_path__ + "static/media/Social_Steam.add66f90.svg";